import React from 'react';

let timelineElements = [

  {
    "id": 1,
    "company": "Xtracut Systems Pvt Ltd - Chennai, India",
    "title": "Technical Lead & Full Stack developer",
    "description": (
      <>
        • Leading technical operations and delivery management for <strong>20+ active web projects</strong>.<br />
        • Managing a team of <strong>15+ Members</strong>, coordinating task allocation, execution, and delivery timelines.<br />
        • Collaborating with <strong>SEO, ads, and marketing teams</strong> for landing page optimization, <strong>CRM integrations</strong>, lead distribution, and funnel setup.<br />
        • Providing technical support for Google Ads and Meta Ads campaigns including <strong>conversion tracking</strong> and automation workflows.<br />
        • Managing <strong>hosting operations, DNS configurations, website deployments</strong>, and security implementations.<br />
        • Implemented <strong>SOPs and operational workflows</strong>, improving delivery efficiency and reducing project delays.<br />
        • Coordinating client communication, escalation handling, and cross-functional collaboration.<br />
        • Led planning and delivery coordination for an internal <strong>AI chatbot MVP</strong> within a <strong>one-week timeline</strong>.<br />
        • Proposed operational strategies for recurring revenue through maintenance and CRM support services.
      </>
    ),
    "date": "Apr 2025 - Present",
    "icon": "work"
  },
  {
    "id": 2,
    "company": "Xtracut Systems Pvt Ltd - Chennai, India",
    "title": "Team Lead & Full Stack developer",
    "description": (
      <>
        • Lead team of <strong>8+</strong> across full SDLC, improving delivery speed by <strong>30%</strong>.<br />
        • Conducted <strong>code reviews</strong>, enforced best practices, and improved team output quality.<br />
        • Migrated websites with <strong>99.9% uptime</strong>; boosted page load speed by <strong>40%</strong>.<br />
        • Coordinated <strong>Agile sprints</strong>, client meetings, and <strong>SOP documentation</strong>.<br />
        • Architected and deployed WordPress, WooCommerce and Custom websites.<br />
        • Delivered <strong>100+ websites</strong> and landing page.<br />
        • Developed full-stack web solutions using <strong>Next.js</strong> for frontend and <strong>Django</strong> for backend architecture.<br />
        • Designed and developed a reusable <strong>college management backend system</strong> to improve scalability and speed of development.
      </>
    ),
    "date": "Apr 2024 - Apr 2025",
    "icon": "work"
  },
  {
    "id": 3,
    "company": "Xtracut Systems Pvt Ltd - Chennai, India",
    "title": "Full Stack developer",
    "description": (
      <>
        • Delivered <strong>60+ websites</strong> and landing page with responsiveness.<br />
        • Enhanced load times by <strong>50%</strong> and SEO rankings by <strong>8-10%</strong>.<br />
        • Built and optimized landing pages using HTML, CSS, and JS.<br />
        • Provided maintenance and client support with a <strong>100% satisfaction rate</strong>.
      </>
    ),
    "date": "Mar 2022 - Mar 2024",
    "icon": "work"
  },
  {
    "id": 4,
    "company": "W3Squad Technology Solutions LLP - Chennai, India",
    "title": "Web Development Intern",
    "description": (
      <>
        • Completed WooCommerce e-commerce project in <strong>2 days</strong>.<br />
        • Collaborated on UI/UX updates; performed QA before deployment.<br />
        • Assisted QA testing and bug fixes, ensuring clean project handovers.
      </>
    ),
    "date": "Oct 2021 - Feb 2022",
    "icon": "work"
  },
  {
    "id": 5,
    "company": "Sardar Raja’s College of Engineering - Alangulam",
    "title": "B.E. Mechanical Engineering",
    "description": "Completed a Bachelor's degree in Mechanical Engineering while pursuing a personal interest in web development. Gained foundational knowledge in problem-solving and technical skills, which later led to a career focus on web development.",
    "date": "June 2016 - Mar 2021",
    "icon": "College"
  }

];
export default timelineElements;